import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const MobileHeaderBackChevronIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        className="Icon mobile-header-back-chevron"
        {...props}
    >
        <path
            fill="#48505E"
            d="M14.293 4.293a1 1 0 0 1 1.414 1.414L9.415 12l6.292 6.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414l7-7z"
        />
    </svg>
);
const Memo = memo(MobileHeaderBackChevronIcon);
export default Memo;
